import { render, staticRenderFns } from "./CustomerLogin.vue?vue&type=template&id=2927a7a8&"
import script from "./CustomerLogin.vue?vue&type=script&lang=ts&"
export * from "./CustomerLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports